var _rect, _rect2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgToastError(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 46,
    height: 46,
    viewBox: "0 0 46 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    fill: "#FEF0C7"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3,
    width: 40,
    height: 40,
    rx: 20,
    stroke: "#FFFAEB",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.9997 19.6657V22.999M22.9997 26.3324H23.008M21.5747 15.3824L14.5163 27.1657C14.3708 27.4177 14.2938 27.7034 14.293 27.9945C14.2922 28.2855 14.3676 28.5716 14.5117 28.8245C14.6558 29.0773 14.8636 29.288 15.1144 29.4356C15.3652 29.5832 15.6503 29.6625 15.9413 29.6657H30.058C30.349 29.6625 30.6341 29.5832 30.8849 29.4356C31.1357 29.288 31.3435 29.0773 31.4876 28.8245C31.6317 28.5716 31.7071 28.2855 31.7063 27.9945C31.7055 27.7034 31.6285 27.4177 31.483 27.1657L24.4247 15.3824C24.2761 15.1375 24.0669 14.935 23.8173 14.7944C23.5677 14.6539 23.2861 14.5801 22.9997 14.5801C22.7132 14.5801 22.4316 14.6539 22.182 14.7944C21.9324 14.935 21.7232 15.1375 21.5747 15.3824Z",
    stroke: "#DC6803",
    strokeWidth: 1.66667,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgToastError);
export default __webpack_public_path__ + "static/media/toast-error.d9f8f6fb148fcd0b72e465e96e6de0e7.svg";
export { ForwardRef as ReactComponent };